export var ExternalLiquidatorProviderEnum;
(function (ExternalLiquidatorProviderEnum) {
    ExternalLiquidatorProviderEnum["BTSE"] = "BTSE";
    ExternalLiquidatorProviderEnum["BYBIT"] = "BYBIT";
    ExternalLiquidatorProviderEnum["KRAKEN"] = "KRAKEN";
    ExternalLiquidatorProviderEnum["WHITEBIT"] = "WHITEBIT";
})(ExternalLiquidatorProviderEnum || (ExternalLiquidatorProviderEnum = {}));
//# sourceMappingURL=external-liquidator-provider.enum.js.map